<template>
    <div>
        <SiteHeader action="help"></SiteHeader>
        <div class="pack-container pack-container--accordion" :class="{'pack-container--iban' : isIban}">
            <!--<BackButton></BackButton>-->
            <PackComponentAccordionIban v-if="isIban"></PackComponentAccordionIban>
            <PackComponentAccordion v-else></PackComponentAccordion>
        </div>
        <div class="flux-body">
            <div class="box" v-if="!_.isEmpty(errors)">
                <div v-for="(error, key) in errors" :key="key">
                    <b-tag>{{ error[0] }}</b-tag>
                </div>
            </div>
            <div class="flux-container">
                <div class="form-container" style="position:relative">
                    <div class="form-nav">
                        <BackButton></BackButton>
                        <ProgressBar v-if="step._show_progress"></ProgressBar>
                    </div>
                    <component :is="active_component"
                               :key="`component-${currentStepName}`"
                               @hook:beforeCreate="componentBeforeCreate"
                               @hook:created="componentCreated"
                               @hook:mounted="componentMounted"
                    ></component>
                    <!--<b-loading :is-full-page="false" v-model="loading"></b-loading>-->
                </div>

            </div>
        </div>
        <SiteFooter></SiteFooter>
    </div>
</template>

<script>
import steps_flux_mixin from "../_commons/fr/mixins/steps_flux_mixin";
import BackButton from "../_commons/fr/BackButton";
import ProgressBar from "../_commons/fr/ProgressBar";
import PackComponent from "../_commons/fr/PackComponentNewBranding";
import {get} from "vuex-pathify";
import SiteHeader from "../_commons/fr/newComponents/SiteHeader";
import SiteFooter from "../_commons/fr/newComponents/SiteFooter";

import InfosModal from "../_commons/fr/modals/InfosModal";
import HelpModal from "../_commons/fr/modals/HelpModal";
import PackComponentAccordion from "../_commons/fr/PackComponentAccordion.vue";
import PackComponentAccordionIban from "../_commons/fr/PackComponentAccordionIban.vue";

export default {
    mixins: [steps_flux_mixin],
    components: {
        BackButton, ProgressBar, PackComponent,SiteFooter,SiteHeader, InfosModal, HelpModal,PackComponentAccordion,PackComponentAccordionIban
    },
    computed: {
        loading: get('func_data/loading'),
        errors: get('form/errors'),
        isIban() {
            return this.$store.get('general_data/current_step') === 'iban'
        }
    }
}
</script>

<style scoped>

</style>
